import { UserRoles } from '@anytag/graphql';

import { refineBasedOnRoleSchema } from '../schema';
import { MarketplaceFormKeys } from '../types';

export const getReferralCodeTrackingFormSchema = (role: UserRoles) =>
  refineBasedOnRoleSchema(role, {
    [MarketplaceFormKeys.title]: true,
    [MarketplaceFormKeys.minAge]: true,
    [MarketplaceFormKeys.maxAge]: true,
    [MarketplaceFormKeys.budget]: true,
    [MarketplaceFormKeys.period]: true,
    [MarketplaceFormKeys.genders]: true,
    [MarketplaceFormKeys.hashtags]: true,
    [MarketplaceFormKeys.clickUrl]: true,
    [MarketplaceFormKeys.countryId]: true,
    [MarketplaceFormKeys.thumbnails]: true,
    [MarketplaceFormKeys.marginRate]: true,
    [MarketplaceFormKeys.requirement]: true,
    [MarketplaceFormKeys.salesPicIds]: true,
    [MarketplaceFormKeys.socialMedia]: true,
    [MarketplaceFormKeys.advertiserId]: true,
    [MarketplaceFormKeys.minFollowers]: true,
    [MarketplaceFormKeys.maxFollowers]: true,
    [MarketplaceFormKeys.preLaunchDate]: true,
    [MarketplaceFormKeys.campaignCategoryId]: true,
    [MarketplaceFormKeys.serviceInformation]: true,
    [MarketplaceFormKeys.influencerCategoryIds]: true,
    [MarketplaceFormKeys.influencerManagementPicIds]: true,
    [MarketplaceFormKeys.costPerOrder]: true,
    [MarketplaceFormKeys.costPerSaleReferral]: true,
    [MarketplaceFormKeys.postTrackingEndDate]: true
  });
